import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-[#050a1a] py-4 md:py-6 px-3 relative overflow-hidden" data-id="element-51">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] bg-[#2563eb] rounded-full blur-[120px] opacity-15 pointer-events-none" data-id="element-52"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-53">
        <h1 className="text-3xl md:text-5xl font-black text-white leading-tight mb-2 text-glow-blue" data-id="element-54">
          Todo tu año de teclado{' '}
          <span className="text-[#eab308] text-glow-yellow" data-id="element-55">listo</span>
        </h1>

        <div className="my-3 cursor-pointer transform hover:scale-[1.02] transition-transform duration-300" onClick={scrollToPricing} data-id="element-56">
          <img src="https://cdn.magicpatterns.com/uploads/aK1yLKr2QXNDPaxnYet36C/mockups_teclado.png" alt="Kit Completo Teclado Listo" className="w-full max-w-lg mx-auto drop-shadow-[0_0_20px_rgba(37,99,235,0.3)]" data-id="element-57" />
        </div>

        <p className="text-gray-300 text-sm md:text-lg font-medium mb-1 max-w-2xl mx-auto leading-snug" data-id="element-58">
          Clases, ejercicios, evaluaciones y repertorio ya armados para que no
          pierdas más tiempo planificando.
        </p>

        <p className="text-[#eab308] font-bold text-base md:text-lg mb-3" data-id="element-59">
          👉 Llegás a cada clase sabiendo exactamente qué hacer.
        </p>

        <div className="flex justify-center mb-2" data-id="element-60">
          <CTAButton onClick={scrollToPricing} variant="primary" className="px-6 py-3 text-sm md:text-base" data-id="element-61">
            SÍ, QUIERO MIS CLASES RESUELTAS
          </CTAButton>
        </div>

        <div className="inline-block bg-[#0f172a] border border-[#1e293b] rounded-full px-4 py-1.5" data-id="element-62">
          <p className="text-gray-400 text-xs md:text-sm font-semibold flex items-center gap-1.5" data-id="element-63">
            <span className="text-[#eab308]" data-id="element-64">★★★★★</span>
            +300 docentes ya usan este sistema
          </p>
        </div>
      </div>
    </section>;
}